/**
 * Splits a csv string into an array. Returns empty array if str is null. Strings are trimmed and empty items are removed.
 */
export function splitCsv(str: string): string[] {
  return (str ?? '')
    .replace(/,\s*$/, '') // Remove trailing comma and spaces
    .split(/,\s*/) // Split on comma with optional spaces
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}
